import React from 'react';

function Warning() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="#E66B45"
			viewBox="0 0 16 16">
			<path
				fill="#E66B45"
				fillRule="evenodd"
				d="M15.333 14.333L8 1.667.667 14.333h14.666zm-8-2V11h1.334v1.333H7.333zm0-2.666h1.334V7H7.333v2.667z"
				clipRule="evenodd"></path>
		</svg>
	);
}

export default Warning;
